export default __webpack_public_path__ + "static/media/GameLead.d639ee16.png";